export type Language = 'zh' | 'en';

type Message = { zh: string; en: string };

export const messages = {
  'ui.help': { zh: '使用帮助', en: 'Help' },
  'ui.closeHelp': { zh: '关闭帮助', en: 'Close help' },
  'ui.planDetails': { zh: '今日计划说明', en: 'About today’s plan' },
  'ui.navigation': { zh: '主导航', en: 'Main navigation' },
  'ui.skipContent': { zh: '跳到主要内容', en: 'Skip to content' },
  'ui.encouragement': { zh: '先完成一点，也是在前进。', en: 'A little progress is still progress.' },
  'ui.minimum': { zh: '保底任务', en: 'Minimum task' },
  'ui.noMinimum': { zh: '今天没有保底任务', en: 'No minimum tasks today' },
  'ui.recommended': { zh: '推荐任务', en: 'Recommended tasks' },
  'ui.optional': { zh: '可选任务', en: 'Optional tasks' },
  'ui.moodNotes': { zh: '心情与备注', en: 'Mood & notes' },
  'ui.markComplete': { zh: '标记完成', en: 'Mark complete' },
  'ui.undoComplete': { zh: '撤销完成', en: 'Undo completion' },
  'ui.finish': { zh: '收工', en: 'Finish today' },
  'ui.skipped': { zh: '已跳过', en: 'Skipped' },
  'ui.restore': { zh: '恢复任务', en: 'Restore task' },
  'ui.taskComplete': { zh: '完成：{title}', en: 'Complete: {title}' },
  'ui.taskAmount': { zh: '完成量：{title}', en: 'Completed amount: {title}' },
  'ui.taskCount': { zh: '{count} 项', en: '{count} tasks' },
  'ui.reviewDetails': { zh: '查看学习概况', en: 'Learning overview' },
  'app.title': { zh: '学习系统陪跑器', en: 'Study Companion' },
  'app.brand': { zh: '学习陪跑', en: 'Study Companion' },
  'app.reminder': {
    zh: '开心和健康最重要，学习不是用来压迫自己和否定自己的。',
    en: 'Your happiness and health matter most. Learning should never become self-punishment.',
  },
  'language.switchToEnglish': { zh: '切换到英文', en: 'Switch to English' },
  'language.switchToChinese': { zh: '切换到中文', en: 'Switch to Chinese' },
  'nav.home': { zh: '首页', en: 'Home' },
  'nav.today': { zh: '今日任务', en: 'Today' },
  'nav.goals': { zh: '目标', en: 'Goals' },
  'nav.history': { zh: '历史', en: 'History' },
  'nav.review': { zh: '复盘', en: 'Review' },
  'nav.settings': { zh: '设置', en: 'Settings' },
  'common.save': { zh: '保存', en: 'Save' },
  'common.cancel': { zh: '取消', en: 'Cancel' },
  'common.backHome': { zh: '返回首页', en: 'Back to Home' },
  'common.none': { zh: '暂无数据', en: 'No data yet' },
  'common.notStarted': { zh: '未启动', en: 'Not started' },
  'common.active': { zh: '进行中', en: 'In progress' },
  'common.submitted': { zh: '已提交', en: 'Submitted' },
  'common.closed': { zh: '已收工', en: 'Closed' },
  'common.enabled': { zh: '激活', en: 'Active' },
  'common.disabled': { zh: '停用', en: 'Inactive' },
  'common.units': { zh: '单位', en: 'units' },
  'common.dayCount': { zh: '{count} 天', en: '{count} days' },

  'dashboard.welcomeTitle': { zh: '学习系统陪跑器', en: 'Study Companion' },
  'dashboard.welcomeText': {
    zh: '这是一个通用学习系统，不是高压打卡器。\n它会帮助你把长期目标拆成每天可以承受的任务，\n并允许你根据状态滚动调整。',
    en: 'This is a flexible learning system, not a high-pressure tracker.\nIt breaks long-term goals into manageable daily tasks\nand adapts as your condition changes.',
  },
  'dashboard.createCycle': { zh: '创建学习周期', en: 'Create a Study Cycle' },
  'dashboard.importData': { zh: '导入已有数据', en: 'Import Existing Data' },
  'dashboard.instructions': { zh: '使用说明', en: 'How It Works' },
  'dashboard.instruction1': { zh: '创建一个学习周期，设定开始和结束日期。', en: 'Create a study cycle with start and end dates.' },
  'dashboard.instruction2': { zh: '添加学习目标（课程、刷题、背诵、阅读等）。', en: 'Add learning goals such as courses, practice, memorization, or reading.' },
  'dashboard.instruction3': { zh: '每天输入启动暗号，系统根据你的进度生成当日任务。', en: 'Enter your launch phrase each day to generate a plan from your progress.' },
  'dashboard.instruction4': { zh: '每天最多一个主线目标，避免多线并行内耗。', en: 'Keep one main goal per day to avoid spreading yourself too thin.' },
  'dashboard.instruction5': { zh: '完成保底任务就算今天没有断线。', en: 'Completing the minimum task keeps your streak alive.' },
  'dashboard.instruction6': { zh: '未完成的任务不会累加到第二天，不制造欠债雪球。', en: 'Unfinished tasks do not roll over and create a debt snowball.' },
  'dashboard.instruction7': { zh: '状态不好时系统会自动降强度。', en: 'The system automatically lowers intensity when you are struggling.' },
  'dashboard.dayIndex': { zh: '第 {count} 天', en: 'Day {count}' },
  'dashboard.studyDay': { zh: '学习日', en: 'Study day' },
  'dashboard.restDay': { zh: '休息日', en: 'Rest day' },
  'dashboard.cycleProgress': { zh: '周期进度 {percent}%', en: 'Cycle progress {percent}%' },
  'dashboard.closedMessage': { zh: '今天已收工。好好休息，明天继续。', en: 'You are done for today. Rest well and continue tomorrow.' },
  'dashboard.viewFeedback': { zh: '查看今日反馈', en: 'View Today’s Feedback' },
  'dashboard.specialDay': { zh: '今天已标记为{mode}：{reason}', en: 'Today is marked as {mode}: {reason}' },
  'dashboard.restMessage': { zh: '今天是休息日。好好恢复，可以回顾一下学习内容。', en: 'Today is a rest day. Recover well, or do a light review if you wish.' },
  'dashboard.markSpecialHint': { zh: '如果想标记今天为特殊日，请前往设置页。', en: 'To mark today as a special day, open Settings.' },
  'dashboard.healthGate': { zh: '健康前置', en: 'Health Check' },
  'dashboard.defaultHealthGate': { zh: '请完成户外活动 / 运动 / 睡眠恢复等健康例行。', en: 'Complete your outdoor activity, exercise, sleep, or recovery routine.' },
  'dashboard.healthDone': { zh: '我已完成', en: 'Completed' },
  'dashboard.healthException': { zh: '今日特例放行', en: 'Allow an Exception Today' },
  'dashboard.planGenerated': { zh: '今日计划已生成。', en: 'Today’s plan is ready.' },
  'dashboard.enterPlan': { zh: '进入今日任务', en: 'Open Today’s Tasks' },
  'dashboard.launchPhrase': { zh: '输入启动暗号', en: 'Enter Launch Phrase' },
  'dashboard.launchHint': { zh: '输入暗号以生成今日学习计划', en: 'Enter the phrase to generate today’s study plan.' },
  'dashboard.launchPlaceholder': { zh: '输入暗号...', en: 'Enter launch phrase...' },
  'dashboard.launch': { zh: '启动', en: 'Start' },
  'dashboard.phraseError': { zh: '暗号不正确，请重试。', en: 'Incorrect phrase. Please try again.' },
  'dashboard.recentRhythm': { zh: '最近 7 天节奏', en: 'Rhythm Over the Last 7 Days' },
  'dashboard.totalProgress': { zh: '周期总进度', en: 'Cycle Progress' },
  'dashboard.activeGoalCount': { zh: '激活目标数', en: 'Active Goals' },
  'dashboard.markToday': { zh: '标记今天为特殊日', en: 'Mark Today as Special' },
  'dashboard.lowCompletionWarning': { zh: '最近完成率偏低，系统已自动降强度。今天完成保底任务就算成功。', en: 'Recent completion is low, so intensity has been reduced. Completing the minimum task is enough today.' },
  'dashboard.unclosedWarning': { zh: '你已经连续多天未收工。建议今天收工一次，帮助系统校准节奏。', en: 'You have left several days open. Close out today to help the system recalibrate.' },
  'dashboard.tooManyGoalsWarning': { zh: '当前激活目标较多（{count} 个），考虑停用部分低优先级目标。', en: 'You have many active goals ({count}). Consider pausing lower-priority goals.' },

  'cycle.createTitle': { zh: '创建学习周期', en: 'Create Study Cycle' },
  'cycle.editTitle': { zh: '编辑学习周期', en: 'Edit Study Cycle' },
  'cycle.subtitle': { zh: '设置你的学习周期规则，系统将据此生成每日任务。', en: 'Set the rules for your cycle and the system will generate daily tasks.' },
  'cycle.name': { zh: '学习周期名称', en: 'Cycle Name' },
  'cycle.namePlaceholder': { zh: '例如：春季备考周期、编程学习计划', en: 'For example: Spring exam prep or Programming plan' },
  'cycle.startDate': { zh: '开始日期', en: 'Start Date' },
  'cycle.endDate': { zh: '结束日期', en: 'End Date' },
  'cycle.dayRule': { zh: '学习日规则', en: 'Study Day Rule' },
  'cycle.weekdays': { zh: '周一至周五学习，周末休息', en: 'Study Monday to Friday; rest on weekends' },
  'cycle.cycleRule': { zh: '学习 N 天休 M 天', en: 'Study N days, rest M days' },
  'cycle.customWeek': { zh: '自定义每周学习日', en: 'Choose study days each week' },
  'cycle.studyDays': { zh: '学习天数', en: 'Study Days' },
  'cycle.restDays': { zh: '休息天数', en: 'Rest Days' },
  'cycle.weekday0': { zh: '周日', en: 'Sun' },
  'cycle.weekday1': { zh: '周一', en: 'Mon' },
  'cycle.weekday2': { zh: '周二', en: 'Tue' },
  'cycle.weekday3': { zh: '周三', en: 'Wed' },
  'cycle.weekday4': { zh: '周四', en: 'Thu' },
  'cycle.weekday5': { zh: '周五', en: 'Fri' },
  'cycle.weekday6': { zh: '周六', en: 'Sat' },
  'cycle.enableHealth': { zh: '开启健康前置', en: 'Enable health check' },
  'cycle.healthHint': { zh: '开启后，每天需要先完成健康例行才能启动学习计划。', en: 'When enabled, complete your health routine before starting the daily plan.' },
  'cycle.healthText': { zh: '健康前置说明', en: 'Health Check Description' },
  'cycle.defaultHealthText': { zh: '完成户外活动 / 运动 / 睡眠恢复', en: 'Complete outdoor activity / exercise / sleep recovery' },
  'cycle.healthPlaceholder': { zh: '完成户外活动 / 运动 / 睡眠恢复 / 休息检查', en: 'Outdoor activity / exercise / sleep recovery / rest check' },
  'cycle.launchPhrase': { zh: '启动暗号', en: 'Launch Phrase' },
  'cycle.defaultLaunchPhrase': { zh: '开始学习', en: 'Start studying' },
  'cycle.launchPhraseHint': { zh: '每天输入暗号后才能生成当日学习计划。', en: 'Enter this phrase each day to generate the daily plan.' },
  'cycle.maxMainGoals': { zh: '每日最多几个主线目标', en: 'Maximum Main Goals per Day' },
  'cycle.maxMainGoalsHint': { zh: '默认 1 个，避免多线并行导致内耗。', en: 'The default is 1 to keep daily focus manageable.' },
  'cycle.hideAmounts': { zh: '打卡反馈中隐藏具体数量（只显示百分比）', en: 'Hide raw amounts in feedback (show percentages only)' },
  'cycle.saveChanges': { zh: '保存修改', en: 'Save Changes' },
  'cycle.create': { zh: '创建学习周期', en: 'Create Cycle' },
  'cycle.archive': { zh: '归档当前周期', en: 'Archive Current Cycle' },
  'cycle.archiveConfirm': { zh: '确定要归档当前学习周期吗？归档后可以创建新周期。', en: 'Archive the current study cycle? You can create a new cycle afterward.' },

  'goal.pageTitle': { zh: '学习目标管理', en: 'Study Goals' },
  'goal.subtitle': { zh: '管理你在当前学习周期中的所有目标。', en: 'Manage every goal in your current study cycle.' },
  'goal.needCycle': { zh: '请先创建学习周期', en: 'Create a study cycle first' },
  'goal.emptyTitle': { zh: '还没有学习目标', en: 'No study goals yet' },
  'goal.emptyDescription': { zh: '添加你的第一个学习目标，系统会根据目标生成每日任务。', en: 'Add your first goal and the system will generate daily tasks from it.' },
  'goal.add': { zh: '添加学习目标', en: 'Add Study Goal' },
  'goal.new': { zh: '新增目标', en: 'New Goal' },
  'goal.edit': { zh: '编辑目标', en: 'Edit Goal' },
  'goal.name': { zh: '目标名称', en: 'Goal Name' },
  'goal.namePlaceholder': { zh: '例如：数据结构课程', en: 'For example: Data Structures course' },
  'goal.category': { zh: '目标类型', en: 'Goal Type' },
  'goal.unit': { zh: '单位', en: 'Unit' },
  'goal.unitPlaceholder': { zh: '例如：章、题、页', en: 'For example: chapters, problems, pages' },
  'goal.totalAmount': { zh: '总量 ({unit})', en: 'Total ({unit})' },
  'goal.completedAmount': { zh: '已完成 ({unit})', en: 'Completed ({unit})' },
  'goal.priority': { zh: '优先级', en: 'Priority' },
  'goal.difficulty': { zh: '难度', en: 'Difficulty' },
  'goal.minimumHint': { zh: '保底任务建议', en: 'Minimum Task Hint' },
  'goal.minimumPlaceholder': { zh: '每天最少做什么？（留空则由系统自动生成）', en: 'What is the smallest daily action? Leave blank for automatic generation.' },
  'goal.recommendedHint': { zh: '推荐任务建议', en: 'Recommended Task Hint' },
  'goal.recommendedPlaceholder': { zh: '正常状态下推荐做什么？', en: 'What should you do on a normal day?' },
  'goal.optionalHint': { zh: '可选任务建议', en: 'Optional Task Hint' },
  'goal.optionalPlaceholder': { zh: '状态好时额外做什么？', en: 'What extra work can you do when feeling good?' },
  'goal.notes': { zh: '备注', en: 'Notes' },
  'goal.notesPlaceholder': { zh: '自由备注...', en: 'Add notes...' },
  'goal.activate': { zh: '激活此目标', en: 'Activate this goal' },
  'goal.deleteConfirm': { zh: '确定要删除这个目标吗？', en: 'Delete this goal?' },
  'goal.pause': { zh: '停用', en: 'Pause' },
  'goal.enable': { zh: '启用', en: 'Enable' },
  'goal.progressAmount': { zh: '完成量：', en: 'Completed:' },
  'goal.cardSubtitle': { zh: '{category} · {difficulty} · 优先级{priority}', en: '{category} · {difficulty} · Priority: {priority}' },
  'goal.category.course': { zh: '课程学习', en: 'Course Study' },
  'goal.category.problems': { zh: '题目训练', en: 'Problem Practice' },
  'goal.category.memory': { zh: '记忆背诵', en: 'Memorization' },
  'goal.category.reading': { zh: '阅读计划', en: 'Reading Plan' },
  'goal.category.project': { zh: '项目开发', en: 'Project Development' },
  'goal.category.custom': { zh: '自定义', en: 'Custom' },
  'goal.priority.high': { zh: '高', en: 'High' },
  'goal.priority.medium': { zh: '中', en: 'Medium' },
  'goal.priority.low': { zh: '低', en: 'Low' },
  'goal.difficulty.easy': { zh: '简单', en: 'Easy' },
  'goal.difficulty.normal': { zh: '中等', en: 'Normal' },
  'goal.difficulty.hard': { zh: '困难', en: 'Hard' },

  'plan.noActiveGoals': { zh: '没有激活的学习目标，请先创建一个学习目标。', en: 'No active study goals. Create a study goal first.' },
  'plan.restReason': { zh: '今天是休息日，好好恢复。', en: 'Today is a rest day. Take time to recover.' },
  'plan.healthPending': { zh: '健康前置未完成，请先完成健康例行再启动今日计划。', en: 'Complete your health routine before starting today’s plan.' },
  'plan.lightReason': { zh: '最近完成率偏低，今天自动切换轻量模式，只保留保底任务。', en: 'Recent completion is low, so today uses light mode with only minimum tasks.' },
  'plan.mainGoalReason': { zh: '今日主线目标：{goalNames}。按正常节奏推进。', en: 'Today’s main goals: {goalNames}. Keep a steady pace.' },
  'plan.restTaskTitle': { zh: '今天是休息日，可以回顾一下学习内容，或做一些轻松的复习。', en: 'Today is a rest day. Review lightly if you feel like it.' },
  'plan.restTaskDescription': { zh: '休息日不强制学习，好好恢复。', en: 'Study is optional on rest days. Focus on recovery.' },
  'plan.specialTitle': { zh: '今天是{mode}：{reason}', en: 'Today is {mode}: {reason}' },
  'plan.blockedDescription': { zh: '客观阻断日，只做轻量维护。', en: 'This is a blocked day. Keep maintenance light.' },
  'plan.specialDescription': { zh: '不生成正常学习任务。', en: 'No regular study tasks are generated.' },
  'plan.specialReason': { zh: '{mode}：{reason}', en: '{mode}: {reason}' },
  'plan.taskTitle': { zh: '[{level}] {action} {goalName}', en: '[{level}] {action} {goalName}' },
  'plan.optionalDescription': { zh: '（可不做）状态好时再完成', en: '(Optional) Complete this only when you feel good.' },
  'plan.action.course': { zh: '学习', en: 'Study' },
  'plan.action.problems': { zh: '练习', en: 'Practice' },
  'plan.action.memory': { zh: '背诵', en: 'Memorize' },
  'plan.action.reading': { zh: '阅读', en: 'Read' },
  'plan.action.project': { zh: '开发', en: 'Build' },
  'plan.action.custom': { zh: '完成', en: 'Complete' },
  'plan.level.minimum': { zh: '保底', en: 'Minimum' },
  'plan.level.recommended': { zh: '推荐', en: 'Recommended' },
  'plan.level.optional': { zh: '可选', en: 'Optional' },
  'plan.mode.normal': { zh: '正常模式', en: 'Normal Mode' },
  'plan.mode.light': { zh: '轻量模式', en: 'Light Mode' },
  'plan.mode.rest': { zh: '休息日', en: 'Rest Day' },
  'plan.mode.holiday': { zh: '放假日', en: 'Holiday' },
  'plan.mode.exam': { zh: '考试日', en: 'Exam Day' },
  'plan.mode.blocked': { zh: '客观阻断日', en: 'Blocked Day' },
  'plan.specialFallback': { zh: '特殊日', en: 'Special Day' },
  'plan.specialMarkFallback': { zh: '特殊标记', en: 'Special Mark' },

  'today.title': { zh: '今日任务', en: 'Today’s Tasks' },
  'today.noPlan': { zh: '今天还没有生成学习计划。请先到首页输入暗号启动。', en: 'No plan has been generated today. Return home and enter your launch phrase.' },
  'today.closed': { zh: '今日已收工。好好休息！', en: 'You are done for today. Rest well!' },
  'today.mainGoal': { zh: '今日主线目标', en: 'Today’s Main Goal' },
  'today.minimumHeading': { zh: '保底任务 — 完成就算今天没有断线', en: 'Minimum Tasks — Complete these to keep your streak' },
  'today.recommendedHeading': { zh: '推荐任务 — 正常状态时推进', en: 'Recommended Tasks — Continue at a normal pace' },
  'today.optionalHeading': { zh: '可选任务 — 状态好时再做，可不做', en: 'Optional Tasks — Do these only when you feel good' },
  'today.noTasks': { zh: '今日没有任务', en: 'No Tasks Today' },
  'today.target': { zh: '目标: {amount} {unit}', en: 'Target: {amount} {unit}' },
  'today.completed': { zh: '已完成: {amount}', en: 'Completed: {amount}' },
  'today.skip': { zh: '跳过', en: 'Skip' },
  'today.skipTitle': { zh: '跳过此任务', en: 'Skip this task' },
  'today.closeTitle': { zh: '收工前确认', en: 'Before You Finish' },
  'today.state': { zh: '今天的状态', en: 'How do you feel today?' },
  'today.state.good': { zh: '好', en: 'Good' },
  'today.state.normal': { zh: '一般', en: 'Okay' },
  'today.state.tired': { zh: '累', en: 'Tired' },
  'today.state.bad': { zh: '差', en: 'Bad' },
  'today.notesPlaceholder': { zh: '今天的学习心得...', en: 'What did you learn today?' },
  'today.blockers': { zh: '客观阻断说明（如有）', en: 'Objective blockers (if any)' },
  'today.blockersPlaceholder': { zh: '例如：临时加班、身体不适...', en: 'For example: overtime or feeling unwell...' },
  'today.close': { zh: '收工 — 结束今天的学习', en: 'Finish — End Today’s Study' },
  'today.closeHint': { zh: '收工后当天结束，不再追加任务。', en: 'After finishing, no more tasks will be added today.' },
  'today.feedbackTitle': { zh: '收工反馈', en: 'Daily Feedback' },
  'today.finishedSubtitle': { zh: '{date} · 今日学习已结束', en: '{date} · Today’s study is complete' },
  'today.completion': { zh: '今日完成量', en: 'Today’s Completion' },
  'today.cumulative': { zh: '累计完成', en: 'Cumulative Progress' },
  'today.expected': { zh: '标准进度', en: 'Expected Progress' },
  'today.summary': { zh: '今日总结', en: 'Today’s Summary' },
  'today.rhythm': { zh: '节奏状态：', en: 'Rhythm: ' },
  'today.blockerLabel': { zh: '客观阻断：{text}', en: 'Blocker: {text}' },
  'today.amountDetails': { zh: '具体完成量', en: 'Completion Details' },
  'today.viewHistory': { zh: '查看历史', en: 'View History' },
  'checkin.minimumCompleted': { zh: '保底任务已完成，今天没有断线。', en: 'You completed the minimum task and kept your streak alive.' },
  'checkin.minimumIncomplete': { zh: '保底任务未完成，但没关系，明天可以重新开始。', en: 'The minimum task was not completed, but you can restart tomorrow.' },
  'checkin.suggestion.ahead': { zh: '你现在略微领先，保持节奏即可，不需要加码。', en: 'You are slightly ahead. Keep this pace without adding more.' },
  'checkin.suggestion.stable': { zh: '节奏稳定，继续按今天这种强度推进。', en: 'Your rhythm is stable. Continue at today’s intensity.' },
  'checkin.suggestion.slightlyBehind': { zh: '略低于标准，不需要补债，明天滚动调整。', en: 'You are slightly behind. Do not repay a debt; adjust tomorrow.' },
  'checkin.suggestion.behind': { zh: '已经明显落后，但不要一次性追赶，先用保底任务把线接回来。', en: 'You are behind, but do not catch up all at once. Reconnect with minimum tasks.' },
  'checkin.suggestion.slipping': { zh: '系统正在滑坡，建议降强度不断线，优先恢复节奏。', en: 'Your system is slipping. Lower intensity and rebuild your rhythm first.' },
  'checkin.suggestion.tired': { zh: '今天状态不好，系统已自动降强度。完成保底任务就算成功。', en: 'You are not feeling well today, so intensity is reduced. The minimum task is enough.' },
  'checkin.detailTitle': { zh: '打卡详情', en: 'Check-in Details' },
  'checkin.notFound': { zh: '未找到打卡记录', en: 'Check-in record not found' },
  'checkin.backHistory': { zh: '返回历史', en: 'Back to History' },
  'checkin.summary': { zh: '总结', en: 'Summary' },
  'checkin.taskDetails': { zh: '任务详情', en: 'Task Details' },
  'rhythm.ahead': { zh: '略微领先', en: 'Slightly Ahead' },
  'rhythm.stable': { zh: '节奏稳定', en: 'Stable' },
  'rhythm.slightlyBehind': { zh: '略低于标准', en: 'Slightly Behind' },
  'rhythm.behind': { zh: '明显落后', en: 'Behind' },
  'rhythm.slipping': { zh: '系统正在滑坡', en: 'Slipping' },

  'history.title': { zh: '历史记录', en: 'History' },
  'history.subtitle': { zh: '回顾你的学习历程', en: 'Review your learning journey' },
  'history.last7': { zh: '最近 7 天', en: 'Last 7 Days' },
  'history.last30': { zh: '最近 30 天', en: 'Last 30 Days' },
  'history.all': { zh: '全部', en: 'All' },
  'history.special': { zh: '特殊日', en: 'Special Days' },
  'history.low': { zh: '低完成日', en: 'Low Completion' },
  'history.empty': { zh: '暂无记录', en: 'No Records Yet' },
  'history.date': { zh: '日期', en: 'Date' },
  'history.mode': { zh: '模式', en: 'Mode' },
  'history.status': { zh: '状态', en: 'Status' },
  'history.completion': { zh: '完成', en: 'Completion' },
  'history.rhythm': { zh: '节奏', en: 'Rhythm' },
  'history.actions': { zh: '操作', en: 'Actions' },
  'history.details': { zh: '详情', en: 'Details' },

  'review.title': { zh: '学习复盘', en: 'Learning Review' },
  'review.subtitle': { zh: '轻量复盘，帮助你了解当前学习状态。', en: 'A lightweight review of your current learning state.' },
  'review.overview': { zh: '周期总览', en: 'Cycle Overview' },
  'review.streak': { zh: '连续收工天数', en: 'Consecutive Closed Days' },
  'review.closedTotal': { zh: '收工/总天数', en: 'Closed / Total Days' },
  'review.restCount': { zh: '休息日数量', en: 'Rest Days' },
  'review.blockedCount': { zh: '客观阻断次数', en: 'Blocked Days' },
  'review.minimumCount': { zh: '保底完成次数', en: 'Minimum Tasks Completed' },
  'review.goalProgress': { zh: '各目标进度', en: 'Goal Progress' },
  'review.noGoals': { zh: '暂无目标', en: 'No goals yet' },
  'review.trend': { zh: '最近 7 天完成趋势', en: 'Completion Trend — Last 7 Days' },
  'review.trendUp': { zh: '趋势向上，继续保持！', en: 'The trend is improving. Keep going!' },
  'review.trendDown': { zh: '趋势有所下降，注意恢复节奏。', en: 'The trend is declining. Focus on restoring your rhythm.' },
  'review.suggestions': { zh: '系统建议', en: 'System Suggestions' },
  'review.lowCompletionSuggestion': { zh: '最近低完成天数较多（{count} 天），建议降强度、优先恢复节奏。', en: 'You have had several low-completion days ({count}). Lower intensity and restore your rhythm first.' },
  'review.tooManyGoalsSuggestion': { zh: '当前激活目标较多（{count} 个），考虑停用部分低优先级目标。', en: 'You have many active goals ({count}). Consider pausing lower-priority goals.' },
  'review.healthSuggestion': { zh: '你已经连续多次绕过健康前置了。学习系统要长期运行，健康规则不能长期失效。', en: 'You have bypassed the health check several times. A sustainable system needs its health rules.' },
  'review.slowProgressSuggestion': { zh: '周期进度明显偏慢，但不要一次性追赶，先用保底任务把线接回来。', en: 'Cycle progress is slow. Do not catch up all at once; reconnect with minimum tasks.' },
  'review.noCloseSuggestion': { zh: '你还没有收工过任何一天。建议今天完成学习后点击收工，帮助系统校准节奏。', en: 'You have not closed any day yet. Finish today to help the system calibrate.' },
  'review.healthySuggestion': { zh: '系统运行总体健康，继续保持当前的节奏。', en: 'Your system is healthy overall. Keep the current rhythm.' },

  'settings.title': { zh: '设置', en: 'Settings' },
  'settings.subtitle': { zh: '管理学习周期、数据和偏好。', en: 'Manage your study cycle, data, and preferences.' },
  'settings.currentPhrase': { zh: '当前暗号', en: 'Current Phrase' },
  'settings.phraseUpdated': { zh: '暗号已更新', en: 'Launch phrase updated' },
  'settings.healthUpdated': { zh: '健康前置规则已更新', en: 'Health check updated' },
  'settings.feedbackUpdated': { zh: '反馈显示规则已更新', en: 'Feedback display updated' },
  'settings.mainGoalsUpdated': { zh: '每日主线目标数量已更新', en: 'Daily main-goal limit updated' },
  'settings.markedToday': { zh: '今天已标记为特殊日', en: 'Today has been marked as a special day' },
  'settings.launchSection': { zh: '启动暗号', en: 'Launch Phrase' },
  'settings.healthSection': { zh: '健康前置规则', en: 'Health Check Rules' },
  'settings.healthPlaceholder': { zh: '健康前置说明...', en: 'Health check description...' },
  'settings.feedbackSection': { zh: '反馈显示', en: 'Feedback Display' },
  'settings.mainGoalsSection': { zh: '每日主线目标', en: 'Daily Main Goals' },
  'settings.markSpecialSection': { zh: '标记今天为特殊日', en: 'Mark Today as Special' },
  'settings.type': { zh: '类型', en: 'Type' },
  'settings.reason': { zh: '原因', en: 'Reason' },
  'settings.reasonPlaceholder': { zh: '说明原因...', en: 'Explain the reason...' },
  'settings.confirmMark': { zh: '确认标记', en: 'Confirm Mark' },
  'settings.markToday': { zh: '标记今天', en: 'Mark Today' },
  'settings.cycleSection': { zh: '学习周期管理', en: 'Study Cycle Management' },
  'settings.editCycle': { zh: '编辑学习周期', en: 'Edit Study Cycle' },
  'settings.dataSection': { zh: '数据管理', en: 'Data Management' },
  'settings.export': { zh: '导出 JSON', en: 'Export JSON' },
  'settings.importFile': { zh: '从文件导入', en: 'Import from File' },
  'settings.manualImport': { zh: '手动粘贴 JSON 导入', en: 'Paste JSON Manually' },
  'settings.jsonPlaceholder': { zh: '粘贴 JSON 数据...', en: 'Paste JSON data...' },
  'settings.import': { zh: '导入', en: 'Import' },
  'settings.importSuccess': { zh: '数据导入成功！请刷新页面查看。', en: 'Data imported successfully. Refresh the page to view it.' },
  'settings.importFailed': { zh: '导入失败', en: 'Import failed' },
  'settings.clear': { zh: '清空所有本地数据', en: 'Clear All Local Data' },
  'settings.clearHint': { zh: '清空前建议先导出备份。', en: 'Export a backup before clearing your data.' },
  'settings.clearConfirm1': { zh: '确定要清空所有本地数据吗？此操作不可恢复。建议先导出备份。', en: 'Clear all local data? This cannot be undone. Export a backup first.' },
  'settings.clearConfirm2': { zh: '再次确认：清空后所有学习数据将永久丢失。', en: 'Confirm again: all learning data will be permanently deleted.' },
  'settings.helpSection': { zh: '使用说明', en: 'Guide' },
  'settings.coreIdea': { zh: '核心理念', en: 'Core Principles' },
  'settings.core1': { zh: '学习系统的目标是长期稳定，不是每天完美。', en: 'The goal is long-term stability, not daily perfection.' },
  'settings.core2': { zh: '每天只生成今天的任务，不提前把未来每天排死。', en: 'Generate only today’s tasks instead of overplanning the future.' },
  'settings.core3': { zh: '每天最多只有一个主线目标，避免多线并行导致内耗。', en: 'Keep one main goal per day to preserve focus.' },
  'settings.core4': { zh: '每个学习日必须有极低启动成本的保底任务。', en: 'Every study day needs a very easy minimum task.' },
  'settings.core5': { zh: '未完成任务不默认累加到第二天，不制造欠债雪球。', en: 'Do not roll unfinished tasks into a debt snowball.' },
  'settings.core6': { zh: '允许休息日、休整日、放假日、考试日和客观阻断日。', en: 'Allow rest, recovery, holidays, exams, and blocked days.' },
  'settings.core7': { zh: '健康前置比学习任务更优先。', en: 'Health checks take priority over study tasks.' },
  'settings.core8': { zh: '收工后当天结束，不再追加强制学习任务。', en: 'Once you finish, no mandatory tasks are added that day.' },
  'settings.core9': { zh: '打卡反馈优先显示百分比和趋势，减少具体数量带来的压力。', en: 'Feedback emphasizes percentages and trends to reduce pressure.' },
  'settings.dailyFlow': { zh: '每日流程', en: 'Daily Flow' },
  'settings.flow1': { zh: '进入首页，完成健康前置（如果开启）。', en: 'Open Home and complete the health check if enabled.' },
  'settings.flow2': { zh: '输入暗号启动今日计划。', en: 'Enter the launch phrase to start today’s plan.' },
  'settings.flow3': { zh: '进入今日任务页，完成保底任务。', en: 'Open Today and complete the minimum task.' },
  'settings.flow4': { zh: '状态好时完成推荐任务和可选任务。', en: 'Complete recommended and optional tasks when feeling good.' },
  'settings.flow5': { zh: '点击收工，查看打卡反馈。', en: 'Finish the day and review your feedback.' },
  'import.invalidFormat': { zh: '数据格式不正确', en: 'Invalid data format' },
  'import.missingFields': { zh: '数据缺少必要字段 (cycles, goals, plans)', en: 'Required fields are missing (cycles, goals, plans)' },
  'import.jsonParse': { zh: 'JSON 解析失败: {detail}', en: 'JSON parsing failed: {detail}' },

  // ===== 重设计新增 =====
  'nav.more': { zh: '更多', en: 'More' },
  'common.close': { zh: '收起', en: 'Close' },
  'common.back': { zh: '返回', en: 'Back' },
  'common.delete': { zh: '删除', en: 'Delete' },
  'common.confirmDelete': { zh: '确认删除？', en: 'Delete for good?' },

  'shell.systemRunning': { zh: '系统已连续运行', en: 'System running for' },
  'shell.streakNote': { zh: '休息日也算系统在运行。', en: 'Rest days count as running.' },
  'shell.streakShort': { zh: '{count} 天', en: '{count}d' },
  'shell.themeDark': { zh: '深色模式', en: 'Dark mode' },
  'shell.themeLight': { zh: '浅色模式', en: 'Light mode' },

  'home.daysUnit': { zh: '天', en: 'days' },
  'home.legendDone': { zh: '完成保底', en: 'Baseline met' },
  'home.legendRest': { zh: '休息日', en: 'Rest day' },
  'home.legendNone': { zh: '未收工', en: 'No wrap-up' },
  'home.step1': { zh: '第一步 · 先照顾身体', en: 'Step 1 · Body first' },
  'home.healthTitle': { zh: '今天的睡眠和运动做完了吗？', en: 'Have you slept and moved today?' },
  'home.healthBody': {
    zh: '健康前置比学习任务更优先。没做完也可以特例放行，系统不会记你一笔。',
    en: 'Health comes before study. You can also let yourself through — nothing is held against you.',
  },
  'home.healthDone': { zh: '我做完了，继续', en: 'Done — continue' },
  'home.healthSkip': { zh: '今天特殊，特例放行', en: 'Special day — let me through' },
  'home.step2': { zh: '第二步 · 亲手启动', en: 'Step 2 · Start it yourself' },
  'home.ritualTitle': { zh: '输入今天的暗号，亲手把系统打开', en: 'Type today’s passphrase to open the system yourself' },
  'home.ritualBody': {
    zh: '计划不会自己推给你。每天由你亲手启动一次——这一下就是今天的开始。',
    en: 'Nothing gets pushed at you. You open it once a day by hand — that single act starts the day.',
  },
  'home.startBtn': { zh: '启动今天的系统', en: 'Start today' },
  'home.codeHintIdle': { zh: '暗号可以在设置里改成任何一句你想对自己说的话。', en: 'You can change the passphrase to any sentence you like in Settings.' },
  'home.codeHintError': { zh: '暗号是「{code}」。它只是一个开关，不是考试。', en: 'The passphrase is “{code}”. It is a switch, not a test.' },
  'home.startedTitle': { zh: '今天的计划已经由你启动', en: 'Today’s plan was started by you' },
  'home.mainGoal': { zh: '今日主线', en: 'Today’s main line' },
  'home.enterToday': { zh: '进入今日任务', en: 'Go to today’s tasks' },
  'home.expected': { zh: '应有进度', en: 'Expected' },
  'home.restNudge': {
    zh: '今天累的话，可以把今天标成休息日——系统会照常记为「在运行」。',
    en: 'If today is heavy, mark it a rest day — the system still counts it as running.',
  },
  'home.emptyTitle': { zh: '还没有学习周期，先开一个吧', en: 'No study cycle yet — let’s open one' },
  'home.emptyBody': {
    zh: '周期是一段有头有尾的时间。系统只在周期里给你排今天，不排未来的每一天。',
    en: 'A cycle is a stretch with a start and an end. The system plans only today inside it — never every future day.',
  },
  'home.principle1': { zh: '周期有头有尾，不是无限期的自我要求。', en: 'A cycle has an end — it is not an open-ended demand on yourself.' },
  'home.principle2': { zh: '每天只排今天，未完成不滚到明天。', en: 'Only today gets planned; unfinished work never rolls over.' },
  'home.principle3': { zh: '休息日、放假日、考试日都算系统在运行。', en: 'Rest days, holidays and exam days all count as the system running.' },

  'today.whyLabel': { zh: '系统为什么这么排', en: 'Why it’s planned this way' },
  'today.levelMin': { zh: '保底 · 完成这个就算今天没有断线', en: 'BASELINE · Do this and today holds' },
  'today.levelRec': { zh: '推荐 · 状态正常时推进', en: 'RECOMMENDED · If today feels normal' },
  'today.minNote': {
    zh: '保底档是今天唯一的成功线。做完就够了，剩下的都是加分。',
    en: 'The baseline is the only success line today. Finish it and today counts — the rest is bonus.',
  },
  'today.optNote': {
    zh: '可选任务不做不影响今天成立，也不会滚到明天。',
    en: 'Skipping optional work changes nothing today, and it never rolls over.',
  },
  'today.optSummaryOpen': { zh: '收起可选任务', en: 'Hide optional work' },
  'today.optSummary': { zh: '状态好的话，还有 {count} 件可选', en: '{count} optional item(s) if you have it in you' },
  'today.optSummaryDone': { zh: '可选任务都做完了', en: 'All optional work done' },
  'today.wrapTitle': { zh: '收工前确认', en: 'Before you wrap up' },
  'today.markDone': { zh: '做完了', en: 'Done' },
  'today.remaining': { zh: '还差 {count} {unit}', en: '{count} {unit} to go' },
  'today.stateNote.good': { zh: '状态好，系统会把推荐档也留在明天的计划里。', en: 'Feeling good — recommended work stays in tomorrow’s plan.' },
  'today.stateNote.normal': { zh: '一般就按正常节奏，保底 + 推荐。', en: 'Normal — baseline plus recommended, as usual.' },
  'today.stateNote.tired': { zh: '选「累」之后，明天自动切轻量模式，只留保底。', en: 'Choosing “tired” switches tomorrow to light mode — baseline only.' },
  'today.stateNote.bad': { zh: '选「差」之后，明天默认休息模式。这不算断线。', en: 'Choosing “rough” makes tomorrow a rest day by default. The chain does not break.' },
  'today.blockHint': {
    zh: '填了阻断，明天的计划会自动降强度，不会当成你没做。',
    en: 'If you note a blocker, tomorrow eases off automatically — it is not counted against you.',
  },
  'today.finishHint': { zh: '收工后当天结束，不再追加任务。', en: 'After wrapping up, the day is closed. Nothing more gets added.' },

  'checkin.title': { zh: '今天收工了', en: 'Today is wrapped' },
  'checkin.todayDone': { zh: '今日完成度', en: 'Today’s completion' },
  'checkin.minMet': { zh: '保底完成 — 今天没有断线。', en: 'Baseline met — today holds.' },
  'checkin.minMissed': { zh: '今天保底没做完，但系统仍在运行——明天会重新排。', en: 'The baseline was missed, but the system is still running — tomorrow gets replanned.' },
  'checkin.cycleCompare': { zh: '放到整个周期看', en: 'Seen across the whole cycle' },
  'checkin.cumulative': { zh: '累计完成', en: 'Cumulative' },
  'checkin.compareNote': { zh: '应有进度只是参考线，不是考核线。', en: 'The expected line is a reference, not a grade.' },
  'checkin.adviceLabel': { zh: '一句话建议', en: 'One line of advice' },
  'checkin.blockRecorded': { zh: '已记录。明天的计划会考虑这件事。', en: 'Recorded. Tomorrow’s plan will take it into account.' },
  'checkin.tomorrow': { zh: '明天会怎么排', en: 'How tomorrow gets planned' },
  'checkin.tomorrowLight': {
    zh: '明天会切到轻量模式，只保留保底任务。你不需要为此解释。',
    en: 'Tomorrow switches to light mode — baseline only. No explanation needed.',
  },
  'checkin.tomorrowNormal': {
    zh: '明天按正常节奏重新排：保底 + 推荐。今天没做完的不会滚过去。',
    en: 'Tomorrow gets replanned as usual: baseline plus recommended. Nothing unfinished rolls over.',
  },
  'checkin.showRaw': { zh: '显示具体数量', en: 'Show raw counts' },
  'checkin.hideRaw': { zh: '只看百分比', en: 'Percentages only' },

  'goal.countSubtitle': { zh: '{active} 个激活 · {total} 个总计', en: '{active} active of {total}' },
  'goal.note': {
    zh: '停用的目标不会出现在今天的任务里，进度也会原样留着，随时可以再打开。',
    en: 'Paused goals leave today’s plan; their progress stays exactly as it is and can be resumed anytime.',
  },
  'goal.resume': { zh: '启用', en: 'Resume' },
  'goal.bump': { zh: '记一笔', en: 'Log one' },
  'common.increase': { zh: '增加', en: 'Increase' },
  'common.decrease': { zh: '减少', en: 'Decrease' },
  'settings.language': { zh: '语言', en: 'Language' },
  'task.status.notStarted': { zh: '未开始', en: 'Not started' },
  'task.status.partial': { zh: '进行中', en: 'In progress' },
  'task.status.completed': { zh: '已完成', en: 'Done' },
  'task.status.skipped': { zh: '已跳过', en: 'Skipped' },
  'task.status.blocked': { zh: '被阻断', en: 'Blocked' },

  'historyNew.subtitle': { zh: '每一天都在这里，包括休息日和 0% 的一天。', en: 'Every day is here — rest days and 0% days included.' },
  'historyNew.note': {
    zh: '这张表不是成绩单。它唯一的用途是让你看到：系统一直在运行。',
    en: 'This is not a report card. Its only job is to show you the system kept running.',
  },

  'reviewNew.weeklyRhythm': { zh: '每周完成节奏', en: 'Weekly rhythm' },
  'reviewNew.weeklyNote': {
    zh: '柱高是当周保底完成率。低的那一周通常有原因，翻历史看看备注。',
    en: 'Bar height is that week’s baseline completion. A low week usually has a reason — check the notes in History.',
  },
  'reviewNew.modeMix': { zh: '日模式分布', en: 'Day-mode mix' },
  'reviewNew.facts': { zh: '这个周期的事实', en: 'Facts about this cycle' },
  'reviewNew.factBaseline': { zh: '天完成了保底', en: 'days met the baseline' },
  'reviewNew.factRest': { zh: '天休息，系统照常运行', en: 'rest days — system kept running' },
  'reviewNew.factMissed': { zh: '天完全没启动', en: 'days never started' },
  'reviewNew.factStreak': { zh: '天连续运行中', en: 'days running in a row' },
  'reviewNew.verdictLabel': { zh: '复盘结论', en: 'Takeaway' },
  'reviewNew.verdict': {
    zh: '你在 {days} 天里保底完成了 {met} 天，休息了 {rest} 天，只有 {missed} 天完全没启动。系统仍然在运行——这就是这个周期到目前为止最重要的结论。',
    en: 'In {days} days you met the baseline on {met}, rested on {rest}, and {missed} day(s) never started. The system is still running — that is the most important takeaway so far.',
  },

  'settingsNew.codewordHint': {
    zh: '每天需要亲手输入它才会生成计划。可以改成任何一句你想对自己说的话。',
    en: 'You type it by hand each day to generate the plan. Make it any sentence you want to say to yourself.',
  },
  'settingsNew.maxMain': { zh: '每日最多主线目标', en: 'Max main goals per day' },
  'settingsNew.maxMainHint': { zh: '建议保持 1。多线并行是内耗的主要来源。', en: 'Keep it at 1. Parallel tracks are the main source of burnout.' },
  'settingsNew.healthToggle': { zh: '开启健康前置', en: 'Health gate on' },
  'settingsNew.healthToggleHint': { zh: '启动学习前先确认睡眠和运动。', en: 'Confirm sleep and movement before studying.' },
  'settingsNew.rawToggle': { zh: '反馈里只显示百分比', en: 'Percentages only in feedback' },
  'settingsNew.rawToggleHint': { zh: '隐藏具体数量，减少数字带来的压力。', en: 'Hide raw counts to take the edge off the numbers.' },
  'settingsNew.darkToggle': { zh: '深色模式', en: 'Dark mode' },
  'settingsNew.darkToggleHint': { zh: '晚间自动降低对比度与亮度。', en: 'Lower brightness and contrast in the evening.' },
  'settingsNew.langHint': { zh: '界面与文案', en: 'Interface and copy' },
  'settingsNew.specialNoteIdle': { zh: '标记后今天不排任务，也不算断线。', en: 'Once marked, today has no tasks and the chain holds.' },
  'settingsNew.specialNoteSet': {
    zh: '今天已标记。系统不会给今天排任务，历史里记为「在运行」。',
    en: 'Marked. No tasks today; History records it as running.',
  },
  'settingsNew.dataTitle': { zh: '数据（全部在本机）', en: 'Data (all local)' },
  'settingsNew.dataHint': { zh: '没有账号、没有后端、没有同步。清空前建议先导出一份。', en: 'No account, no backend, no sync. Export a copy before clearing.' },
  'settingsNew.manual': { zh: '使用说明', en: 'How this works' },
  'settingsNew.manual1': { zh: '系统的目标是长期稳定，不是每天完美。', en: 'The goal is long-term steadiness, not a perfect day.' },
  'settingsNew.manual2': { zh: '每天只生成今天的任务，不提前把未来排死。', en: 'Only today is generated — the future is never locked in.' },
  'settingsNew.manual3': { zh: '每天最多一个主线目标，避免多线并行内耗。', en: 'At most one main goal a day, to avoid burnout from parallel tracks.' },
  'settingsNew.manual4': { zh: '未完成不滚存到第二天，第二天是重新规划。', en: 'Unfinished work never rolls over; tomorrow is replanned from scratch.' },
  'settingsNew.manual5': { zh: '状态不好时系统自动降强度，你不需要解释。', en: 'When you are struggling the system eases off — no explanation needed.' },
  'settingsNew.manual6': { zh: '收工后当天结束，不再追加任务。', en: 'Once you wrap up, the day is closed.' },

  'setupNew.subtitle': {
    zh: '只需要起止日期和固定休息日。任务由系统每天现算，不提前排满。',
    en: 'Only start, end, and fixed rest days. Tasks are computed each morning — never scheduled months ahead.',
  },
  'setupNew.previewLabel': { zh: '系统会怎么理解这个周期', en: 'How the system reads this' },
  'setupNew.preview': {
    zh: '共 {days} 天，其中约 {study} 个学习日。系统只会在学习日给你排任务；休息日不排、也不算断线。',
    en: '{days} days total, about {study} study days. Tasks appear only on study days — rest days generate none and never break the chain.',
  },
  'settingsNew.privacy': { zh: '隐私政策', en: 'Privacy policy' },
  'settingsNew.privacyHint': {
    zh: '不收集任何信息，数据只存在你自己的设备上。',
    en: 'Nothing is collected; your data stays on your own device.',
  },
  // ===== 账号 =====
  'account.defaultName': { zh: '我的学习', en: 'My study' },
  'account.title': { zh: '账号', en: 'Accounts' },
  'account.subtitle': {
    zh: '同一台设备上的多套数据，互不影响。账号只存在这台设备上。',
    en: 'Separate sets of data on this device. Accounts live only on this device.',
  },
  'account.current': { zh: '当前', en: 'Current' },
  'account.switch': { zh: '切换账号', en: 'Switch account' },
  'account.switchOther': { zh: '换一个账号', en: 'Use another account' },
  'account.create': { zh: '新建账号', en: 'New account' },
  'account.namePlaceholder': { zh: '账号名称，例如 考研', en: 'Account name, e.g. Exam prep' },
  'account.rename': { zh: '改名', en: 'Rename' },
  'account.locked': { zh: '已加密', en: 'Encrypted' },
  'account.lock': { zh: '立即锁定', en: 'Lock now' },
  'account.password': { zh: '密码', en: 'Password' },
  'account.passwordPlaceholder': { zh: '输入密码…', en: 'Enter password…' },
  'account.setPassword': { zh: '设置密码', en: 'Set password' },
  'account.changePassword': { zh: '修改密码', en: 'Change password' },
  'account.removePassword': { zh: '取消密码', en: 'Remove password' },
  'account.currentPassword': { zh: '当前密码', en: 'Current password' },
  'account.newPassword': { zh: '新密码', en: 'New password' },
  'account.confirmPassword': { zh: '再输一次', en: 'Confirm password' },
  'account.passwordMismatch': { zh: '两次输入不一致。', en: 'The two entries do not match.' },
  'account.passwordTooShort': { zh: '密码至少 4 位。', en: 'Use at least 4 characters.' },
  'account.wrongPassword': {
    zh: '密码不对。再试一次——没有次数限制。',
    en: 'That password did not work. Try again — there is no attempt limit.',
  },
  'account.unlock': { zh: '解锁', en: 'Unlock' },
  'account.unlocking': { zh: '解锁中…', en: 'Unlocking…' },
  'account.unlockHint': { zh: '这个账号的数据是加密的，输入密码后才能打开。', en: 'This account is encrypted. Enter its password to open it.' },
  'account.rememberSession': {
    zh: '本次浏览器会话内记住（关掉标签页就失效）',
    en: 'Remember for this browser session (cleared when the tab closes)',
  },
  'account.passwordWarning': {
    zh: '说清楚两件事：一、忘记密码就无法恢复数据——没有服务器，我们也重置不了。二、这层加密防的是别人顺手点开你的浏览器，防不住能完整读取你设备存储的人。',
    en: 'Two things to be clear about: first, if you forget this password the data cannot be recovered — there is no server, so nobody can reset it. Second, this protects against someone casually opening your browser, not against someone with full access to your device storage.',
  },
  'account.deleteWarning': {
    zh: '删除账号会一并删掉它的全部学习记录，且无法撤销。建议先导出备份。',
    en: 'Deleting an account also deletes all of its records, and cannot be undone. Export a backup first.',
  },
  'account.lastOne': { zh: '这是唯一的账号，不能删除。', en: 'This is the only account; it cannot be deleted.' },
  'account.switchFirst': {
    zh: '要改这个账号的密码，请先切换到它——改密码需要用新密码把数据重新加密一遍。',
    en: 'Switch to this account first: changing its password re-encrypts its data, which requires the account to be open.',
  },
  'account.dataNote': {
    zh: '每个账号的数据分开存放在这台设备上。导出、导入和清空都只作用于当前账号。',
    en: 'Each account is stored separately on this device. Export, import and clear apply to the current account only.',
  },

  'setupNew.restDaysHint': { zh: '休息日不会生成任务，也不会算断线。', en: 'Rest days generate no tasks and never break the chain.' },
} as const satisfies Record<string, Message>;

export type TranslationKey = keyof typeof messages;
export interface TranslationReference {
  key: TranslationKey;
}
export type TranslationValue = string | number | readonly string[] | TranslationReference;
export type TranslationValues = Record<string, TranslationValue>;

export interface LocalizedMessage {
  key: TranslationKey;
  values?: TranslationValues;
}

function formatList(language: Language, values: readonly string[]): string {
  if (values.length < 2) return values[0] ?? '';
  const last = values[values.length - 1];
  if (language === 'zh') return `${values.slice(0, -1).join('、')}和${last}`;
  if (values.length === 2) return `${values[0]} and ${values[1]}`;
  return `${values.slice(0, -1).join(', ')}, and ${last}`;
}

export function translate(
  language: Language,
  key: TranslationKey,
  values: TranslationValues = {},
): string {
  const template = messages[key][language];
  return template.replace(/\{(\w+)\}/g, (_match, name: string) => {
    const value = values[name];
    if (Array.isArray(value)) return formatList(language, value.map(String));
    if (typeof value === 'object' && value !== null && 'key' in value) {
      return translate(language, value.key);
    }
    return value === undefined ? `{${name}}` : String(value);
  });
}

export function resolveLocalizedMessage(
  language: Language,
  message: LocalizedMessage | undefined,
  fallback: string,
): string {
  return message ? translate(language, message.key, message.values) : fallback;
}
